import { getPostedRequests } from "../Outbox/Module";

// -------------------------------------------------------------------< constants >-------------------------------------------------------------------
const GET_DRAFT_REQUESTS_SUCCESS = 'GET_DRAFT_REQUESTS_SUCCESS';
const GET_DRAFT_REQUEST_SUCCESS = 'GET_DRAFT_REQUEST_SUCCESS';
const SEND_DRAFT_REQUEST_SUCCESS = 'SEND_DRAFT_REQUEST_SUCCESS';
const UPDATE_DRAFT_REQUEST_SUCCESS = 'UPDATE_DRAFT_REQUEST_SUCCESS';
const DESTROY_DRAFT_REQUEST_SUCCESS = 'DESTROY_DRAFT_REQUEST_SUCCESS';

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

/**
 *
 * @param {*} payload
 * @return {{type: string, payload: *}}
 */
function _indexRequestsSuccess(payload) {
  return {
    type: GET_DRAFT_REQUESTS_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {*} payload
 * @return {{type: object, payload: *}}
 */
function _showRequestSuccess(payload) {
  return {
    type: GET_DRAFT_REQUEST_SUCCESS,
    payload: payload.data,
  };
}


/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _sendSuccess(payload) {
  return {
    type: SEND_DRAFT_REQUEST_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _updateSuccess(payload) {
  return {
    type: UPDATE_DRAFT_REQUEST_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {Number} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _destroySuccess(payload) {
  return {
    type: DESTROY_DRAFT_REQUEST_SUCCESS,
    payload: payload,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------
/**
 * @param {Number} currentUser
 * @param {object} params
 * @param {function} callback
 * @return {Function}
 */
export function getRequests(currentUser, params = {}, callback = (r) => {
}) {
  return (dispatch, gs, api) => {
    api.get(`/user/requests/draft`, {params})
      .then((r) => {
        dispatch(_indexRequestsSuccess(r));
        callback(r);
      })
      .catch((e) => {
      });
  };
}

/**
 * @param {Number} id
 * @param {Object} params
 * @param {function} callback
 * @return {Function}
 */
export function getRequest(id, params = {}, callback = () => {
}) {
  return (dispatch, gs, api) => {
    api.get(`/requests/draft/${id}`, {params})
      .then((r) => {
        // console.log('ق', r);
        dispatch(_showRequestSuccess(r));
        callback(r);
      })
      .catch((e) => {
        // console.log('', e);
      });
  };
}

/**
 *
 * @param {Object} data
 * @param {string} acceptAll
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function send(data, acceptAll, callback = () => {
}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(app.translate('routes.home.requests.Sending Request'));
    api.post(`/requests/draft/send${acceptAll}`, {data})
      .then((r) => {
        if (r.data.id || (r.data[0] && r.data[0].id)) {
          dispatch(_sendSuccess(r));
          dispatch(getPostedRequests());      
          loader.hide(() => app.message(app.translate('routes.home.requests.One Request Send Successfully')));
          callback();
        } else {
          loader.hide(() => app.message(app.translate('routes.home.requests.Please check it')));
          callback(r);
        }
      })
      .catch((e) => {
        loader.hide(() => {
          if (e.response && e.response.data) {
            //  console.log(e.response);
            callback(e.response.data, 'send');
            return app.translate('routes.home.requests.Please check it');
          } else {
            return app.translate('routes.home.requests.Sending New Request Failed');
          }
        });
        // loader.hide(() => app.error(
        //   e, 'routes.home.requests.dashboard', 'Request',
        //   (() => {
        //     if (e.response && e.response.data) {
        //       callback(e.response.data, 'send');
        //       return app.translate('routes.home.requests.Please check it');
        //     } else {
        //       return app.translate('routes.home.requests.Adding New Request Failed');
        //     }
        //   })(),
        // ));
      });
  };
}

export function getRequestFormFields(){}
export function getRequestStateDiagram(){}

/**
 *
 * @param {Number} request
 * @param {Object} data
 * @param {string} acceptAll
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function update(request, data, acceptAll, callback = () => {
}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(app.translate('routes.home.requests.Updating Request', 'Updating Request'));
    api.put(`/requests/draft/${request}${acceptAll}`, {data})
      .then((r) => {
        if (r.data.id) {
          dispatch(_updateSuccess(r));
          loader.hide(() => app.message(app.translate('routes.home.requests.Request Update Successfully', 'Request Update Successfully')));
          callback(undefined, r);
        } else {
          loader.hide(() => app.message(app.translate('routes.home.requests.Please check it')));
          callback(r, 'update');
        }
      })
      .catch((e) => {
        loader.hide(() => app.error(
          e, 'routes.home.requests.dashboard', 'عملیات بروزرسانی با شکست مواجه شد',
          (() => {
            if (e.response && e.response.data) {
              callback(e.response.data, 'update');
              return app.translate('routes.home.requests.Please check it');
            } else {
              return app.translate('routes.home.requests.Updating Request Failed');
            }
          })(),
        ));
      });
  };
}

/**
 *
 * @param {Number} request
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function destroy(request, params = {}, callback = () => {
}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(app.translate('routes.home.requests.Removing Request'));
    api.delete(`/requests/draft/${request}`, {params})
      .then((r) => {
        if (!app._.isEmpty(r.data) && (r.data.confirm || r.data.notice)) {
          loader.hide(() => app.message(app.translate('routes.home.requests.Please check it')));
          callback(r, 'destroy');
        } else {
          dispatch(_destroySuccess(request));
          loader.hide(() => app.message(app.translate('routes.home.requests.Request Removed Successfully')));
          callback(r);
        }
      })
      .catch((e) => {
        loader.hide(() => app.error(
          e, 'routes.home.requests.dashboard', 'عملیات حذف با شکست مواجه شد',
          app.translate('routes.home.requests.Removing Request Failed'),
        ));
      });
  };
}
/**
 *
 * @return {{type: string, payload: *}}
 */
export function emptyRequests() {
  return _indexRequestsSuccess({data: {drafts: []}, meta: {}});
}

/**
 *
 * @return {{type: Object, payload: *}}
 */
export function emptyRequest() {
  return _showRequestSuccess({data: {request: null}});
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {object} state
 * @param {object} action
 * @return {object}
 */
export default function reducer(state = {
  requests: [],
  request: {},
  meta: {},
}, action) {
  let requests;
  let _index;

  switch (action.type) {
    case GET_DRAFT_REQUESTS_SUCCESS:
      return Object.assign({}, state, {
        requests: action.payload.data.drafts,
        meta: action.payload.meta,
      });
    case GET_DRAFT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        request: action.payload.request,
      });
    case SEND_DRAFT_REQUEST_SUCCESS:

      requests = app._.cloneDeep(state.requests);
      _index = requests.findIndex((_request) => _request.id === action.payload.id);
      requests.splice(_index, 1);
      return Object.assign({}, state, {
        requests,
      });
    case UPDATE_DRAFT_REQUEST_SUCCESS:
      requests = app._.cloneDeep(state.requests);
      _index = requests.findIndex((_request) => _request.id === action.payload.id);
      requests[_index] = action.payload;
      return Object.assign({}, state, {
        requests,
      });
    case DESTROY_DRAFT_REQUEST_SUCCESS:
      requests = app._.cloneDeep(state.requests);
      _index = requests.findIndex((_request) => _request.id === action.payload);
      requests.splice(_index, 1);
      return Object.assign({}, state, {
        requests,
      });
    default:
      return state;
  }
}
